// redux utils
import { createAsyncThunk } from '@reduxjs/toolkit';
// api
import * as rms from './api/rms'



// thunks
export const fetchRevenueDetailData = createAsyncThunk('revenue/fetchRevenueDetailData', async requestData => {
    const response = await rms.postRevenueDetailRequest(requestData);
    return response.data
});